import { render, staticRenderFns } from "./InfoUser.vue?vue&type=template&id=b043df74&"
import script from "./InfoUser.vue?vue&type=script&lang=js&"
export * from "./InfoUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports